/**
 * Helpers for the reward `progress_start_at` date picker. Kept pure and separate from the UI so
 * they can be unit-tested — this value decides which points count toward a reward, so its
 * round-trip correctness matters.
 */

/** Local calendar date (YYYY-MM-DD) → UTC ISO at the start of that local day. */
export function dateInputToProgressStartAtIso(dateStr: string): string {
  const parts = dateStr.split('-').map(Number);
  if (parts.length !== 3 || parts.some((n) => !Number.isFinite(n))) return new Date().toISOString();
  const [y, m, d] = parts;
  return new Date(y, m - 1, d, 0, 0, 0, 0).toISOString();
}

/** UTC ISO → local calendar date (YYYY-MM-DD) for the date input. */
export function isoToDateInputValue(iso: string): string {
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
